// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { getMemoOccupationSelections } from './utils';

const Occupation = props => {
  useMountLogging('Occupation');
  const occupation = useStoreState(({ form }) => form.occupation);
  const occupationSelections = getMemoOccupationSelections();

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      emptyOption={{ enabled: true }}
      focusHandler={props.focusHandler}
      id="occupation"
      label={getContent('fieldLabels.occupation')}
      required={true}
      selectOptions={occupationSelections}
      {...occupation}
    />
  );
};

Occupation.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { Occupation };
